import React from 'react';
import { CheckIcon, SproutIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['Garantía de 7 días', 'Pago seguro', 'Acceso inmediato', 'Material listo para usar desde hoy'];
export function FinalCta() {
  return <section className="tech-grid bg-navy-900 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-76" data-mp="1jcd58c5js2d2">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-77" data-mp="1eetsjgohzxn8">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-leaf-400" data-id="element-78" data-mp="1ec7ldi5irk5j">
          <SproutIcon className="h-4 w-4" aria-hidden="true" data-id="element-79" data-mp="1o43leyr61kce" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-white sm:text-4xl" data-id="element-80" data-mp="223mi8vej199e">
          Hecho por especialistas, para docentes de Latinoamérica.
        </h2>

        <Countdown light className="mt-8" data-id="element-81" data-mp="n5ul3zmwvjfp" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border border-navy-100 bg-white p-6 text-left shadow-2xl sm:flex-row sm:items-center sm:justify-between" data-id="element-82" data-mp="n75mxtwsqh46">
          <p data-id="element-83" data-mp="x38wvlxw3k1o">
            <b className="block font-display text-base leading-tight text-navy-900" data-id="element-84" data-mp="x2qt848we3jq">{productShortName}</b>
            <span className="text-sm text-navy-700" data-id="element-85" data-mp="123mxwk12ptq7">
              {totalVolumes} tomos + {totalBonuses} bonos · Acceso inmediato
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-86" data-mp="1b3a21dl6tdmy">
            <p className="text-sm text-navy-700" data-id="element-87" data-mp="1b1yxhbjx41us">
              <span className="mr-2 line-through" data-id="element-88" data-mp="1fujknu8bjgpc">{priceBefore}</span>
              <b className="text-lg text-navy-900" data-id="element-89" data-mp="1fwmbuhl7jfvn">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-90" data-mp="1ksth085s4ncj">
              Quiero mi Megapack ahora
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-navy-100" data-id="element-91" data-mp="1tuklxashwq5c">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-92" data-mp="3lvubnktrir12">
              <CheckIcon className="h-4 w-4 text-leaf-400" aria-hidden="true" data-id="element-93" data-mp="3ltrgkmdr67ph" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}